export const end_message = `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
width="52px" height="52px" viewBox="0 0 52 52" enable-background="new 0 0 52 52" xml:space="preserve">
<g>
<path d="M24.6,40.6c0-2.8,0.7-5.4,2-7.7h-2.3c-0.5,0-0.8-0.3-0.8-0.8v-9.2c0-0.5,0.3-0.8,0.8-0.8h9.2
   c0.5,0,0.8,0.3,0.8,0.8v3c1.9-0.8,4.1-1.3,6.3-1.3c1.5,0,2.9,0.2,4.2,0.6c0.2-1.1,0.3-2.2,0.3-3.3C45,10.9,35.5,2.1,23.6,2.1
   c-11.9,0-21.4,8.8-21.4,19.6c0,3.4,1,6.6,2.6,9.5c0.3,0.4,0.4,1,0.2,1.5l-2.8,7.6c-0.3,0.7,0.4,1.3,1.2,1.2l7.7-3
   c0.4-0.2,1-0.1,1.5,0.2c3.2,1.8,7.1,2.9,11.2,2.9c0.3,0,0.6,0,0.8,0C24.6,41.3,24.6,41,24.6,40.6z M12.8,12.2
   c0-0.5,0.3-0.8,0.8-0.8h19.9c0.5,0,0.8,0.3,0.8,0.8v4.6c0,0.5-0.4,0.8-0.9,0.8H13.6c-0.5,0-0.8-0.3-0.8-0.8V12.2z M19,32.1
   c0,0.5-0.4,0.8-0.9,0.8h-4.6c-0.5,0-0.8-0.3-0.8-0.8v-9.2c0-0.5,0.3-0.8,0.8-0.8h4.7c0.5,0,0.8,0.3,0.8,0.8V32.1z"/>
</g>
<path d="M31.8,34.6l6,6l-6,6c-0.6,0.6-0.6,1.6,0,2.1l0.7,0.7c0.6,0.6,1.6,0.6,2.1,0l6-6l6,6c0.6,0.6,1.6,0.6,2.1,0
l0.7-0.7c0.6-0.6,0.6-1.6,0-2.1l-6-6l6-6c0.6-0.6,0.6-1.6,0-2.1l-0.7-0.7c-0.6-0.6-1.6-0.6-2.1,0l-6,6l-6-6c-0.6-0.6-1.6-0.6-2.1,0
l-0.7,0.7C31.2,33.1,31.2,34.1,31.8,34.6z"/>
</svg>
`;